module.exports = __webpack_public_path__ + "img/infografica-img-04.a4c8ba2a.png";